import styled from 'styled-components';

const ChatContainer = styled.div`
  max-width: 100%;
  width: 100%;
  height: 100%;
  min-height: 0;
  position: relative;
  display: flex;
  flex-direction: row;
`;

export {
  ChatContainer,
};
